export enum VersionViewType {
  PARTFINITI = 'partfiniti',
  PARTFINITI_V2 = 'partfiniti_v2',
}
